import services from '../../../services'

const state = {
  updateTime: '',
  updatePlace: ''
}

const actions = {
  async placeTree ({commit}, query) {
    return await services.place_loadTree(query)
  },
  async getPlaceById ({commit}, query) {
    return (await services.place_byId(query))
  },
  async addPlaceTree ({commit}, options) {
    return await services.place_addTree(options)
  },
  async deletePlaceTree ({commit}, query) {
    return await services.place_delete(query)
  },
  async updatePlaceTree ({commit}, options) {
    return await services.place_update(options)
  },
  async getTenantConfig ({commit}) {
    return await services.place_tenantConfig()
  },
  async movePlaceTree ({commit}, options) {
    return await services.place_move(options)
  },
  async place_find({commit}, data) {
    return await services.place_find(data)
  },
  async place_regionWidthFeature({commit}, data){
    return await services.place_regionWidthFeature(data)
  },
  async isExistUseSpace_region({commit}, data) {
    return await services.isExistUseSpace(data)
  },
  async getAreaCode({commit}) {
    return await services.place_getAreaCode()
  }
}

const mutations = {
  placeUpdate (state, time, placeId) {
    state.updateTime = time
    state.updatePlace = placeId
  }
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/place.js